import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

export const MuiAutocomplete: Components<Theme>['MuiAutocomplete'] = {
  styleOverrides: {
    root: () => ({
      '& .MuiFilledInput-root': {
        paddingTop: 0,
        paddingLeft: 0,
        paddingRight: '16px !important',
        '& .MuiAutocomplete-endAdornment': {
          right: '16px',
        },
        '& .MuiFilledInput-input': {
          padding: '26px 16px 6px !important',
        },
      },
    }),
    listbox: () => ({
      paddingBlock: 0,
      flexGrow: 1,
    }),
    option: ({ theme }) => ({
      padding: '14px 20px !important',
      fontSize: '14px',
      lineHeight: 1.5,
      fontWeight: 500,
      '&[aria-selected="true"]': {
        backgroundColor: '#F8FAFE',
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: '#EEF2FD',
        },
        '&.Mui-focused': {
          backgroundColor: '#F8FAFE !important',
        },
      },
      '&:hover, &.Mui-focused': {
        backgroundColor: '#EEF2FD',
      },
    }),
    noOptions: () => ({
      fontSize: '14px',
      lineHeight: 1.5,
      fontWeight: 500,
    }),
    paper: () => ({
      display: 'flex',
    }),
  },
};
